import Container from '../../../elements/Container'
import { addLinkTarget } from '../../../helpers/addLinkTarget'
import styles from './styles.module.scss'

const Paragraph = ({ content }) => (
  <div className={styles.paragraph}>
    <Container variant={['-xs2', '-pxl']}>
      <div
        dangerouslySetInnerHTML={{
          __html: addLinkTarget(content)
        }}
      ></div>
    </Container>
  </div>
)

export default Paragraph
